import design from '../../assets/karenying-design.png';

import '../../styles/days.scss';

const Nineteen = () => (
  <div className='days full-image'>
    <img src={design} alt='neural net' />
  </div>
);

export default Nineteen;
